import React from 'react';
import { SpaceContainer } from './styles';

export const BackgroundNavbar = () => {
  return <SpaceContainer></SpaceContainer>;
};
